module.exports = __webpack_public_path__ + "img/modules/assets/img/ext_default.3251aafacc48fddd8845bbdd390e4d16.png";